import React, {FC, useEffect, useState} from "react";
import {Button, Col, DatePicker, Drawer, Form, Input, InputNumber, Row, Select, Spin} from "antd";
import {Trans} from "@lingui/macro";
import {useAxios} from "../utils/hooks";
import {openNotification} from "../utils/openNotification";
import moment from "moment";

interface QuickDDSAssignmentProps {
    visible: boolean;
    order: any;
    onClose: () => void;
    onSuccess: () => void;
}

const QuickDDSAssignment: FC<QuickDDSAssignmentProps> = ({ visible, order, onClose, onSuccess }) => {
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible && order) {
            form.setFieldsValue({
                itemNo: order.itemNo || (order.item && order.item.itemNo),
                validFrom: moment(),
                validTo: moment().add(1, 'year')
            });
        }
    }, [visible, order]);

    const handleSubmit = () => {

        console.log(order);
        form.validateFields().then(values => {
            if (axiosInstance.current != null) {
                setLoading(true);

                axiosInstance.current
                    .post('/resource/orders/add-dds-number-by-manually?' +
                        'ddsNumber=' + values.ddsNumber +
                        '&ddsValidFrom=' + (values.validFrom ? moment(values.validFrom).format('YYYY-MM-DD') : null) +
                        '&ddsValidTo=' + (values.validTo ? moment(values.validTo).format('YYYY-MM-DD') : null) +
                        '&orderId=' + order.id
                        , {})
                    .then(() => {
                        openNotification('customSuccess', 'DDS Assignment created successfully.');
                        form.resetFields();
                        onSuccess();
                        onClose();
                    })
                    .catch(function (error: any) {
                        openNotification('error', error);
                    })
                    .finally(() => {
                        setLoading(false);
                    });
            }
        });
    };

    return (
        <Drawer
            title={<Trans>Quick DDS Assignment</Trans>}
            placement="right"
            width={500}
            onClose={onClose}
            visible={visible}
            footer={
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={onClose} style={{ marginRight: 8 }}>
                        <Trans>Cancel</Trans>
                    </Button>
                    <Button onClick={handleSubmit} type="primary" loading={loading}>
                        <Trans>Assign DDS</Trans>
                    </Button>
                </div>
            }
        >
            <Spin spinning={loading}>
                <Form form={form} layout="vertical">
                    {order && (
                        <div style={{ marginBottom: 16, padding: 12, background: '#f5f5f5', borderRadius: 4 }}>
                            <p style={{ margin: 0 }}><strong><Trans>Order No:</Trans></strong> {order.orderNo}</p>
                            <p style={{ margin: 0 }}><strong><Trans>Item:</Trans></strong> {order.itemNo || (order.item && order.item.itemNo)}</p>
                        </div>
                    )}

                    <Form.Item
                        name="ddsNumber"
                        label={<Trans>DDS Number</Trans>}
                        rules={[{ required: true, message: <Trans>Please enter DDS number</Trans> }]}
                    >
                        <Input style={{ width: '100%' }} placeholder="Enter DDS number" />
                    </Form.Item>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                name="validFrom"
                                label={<Trans>Valid From</Trans>}
                            >
                                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="validTo"
                                label={<Trans>Valid To</Trans>}
                            >
                                <DatePicker style={{ width: '100%' }} format="YYYY-MM-DD" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Spin>
        </Drawer>
    );
};

export default QuickDDSAssignment;
